// extracted by mini-css-extract-plugin
module.exports = {"noReportsMessage":"NoReportsMessage_noReportsMessage__oDx5f"};